import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import _defineProperty from "D:/java/\u4E00\u7F51\u901A\u529E(\u529E\u4E8B\u5927\u53852.0)/\u4E00\u7F51\u901A\u529E\u524D\u7AEFPC/pc/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { bpmnCountPersonProcess } from "@/api/bpmnApi/bpmn";
import { mapGetters } from "vuex";
export default {
  name: "Sidebar",
  components: {},
  props: {},
  data: function data() {
    return {
      baseUrl: process.env.BASE_URL,
      hidePath: ["/management"],
      tabJson: {},
      rightShow: "2"
    };
  },
  computed: _objectSpread({}, mapGetters(["userData"])),
  created: function created() {},
  mounted: function mounted() {
    this.getBpmnCountPersonProcess();
  },
  destroyed: function destroyed() {},
  methods: {
    setClass: function setClass(val) {
      this.rightShow = val;
    },
    getBpmnCountPersonProcess: function getBpmnCountPersonProcess() {
      var _this = this;

      bpmnCountPersonProcess().then(function (_ref) {
        var data = _ref.data;

        if (data.code == 0) {
          _this.tabJson = data.data || {};
        } else {}
      }).catch(function (err) {});
    },
    hasItem: function hasItem(path) {
      return (this.userData.routerData || []).includes(path);
    },
    isAdmin: function isAdmin() {
      return (this.userData.roleCodes || []).includes("ROLE_ADMIN");
    }
  },
  watch: {
    $route: function $route() {
      this.getBpmnCountPersonProcess();
    }
  },
  filters: {}
};